import React, { useEffect, useState } from "react";
import { Button, Image } from "react-bootstrap";
import SuperAdminNotification from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
// import { SuperAdminBlockUser } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser";
import SuperAdminCall from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
// import { SuperAdminFlag } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag";
// import { SuperAdminVendorViewDetailsPopup } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminVendorViewDetailsPopup";
//import PendingAddRatingReview from "../superAdminPendingVendors/superAdminVendorTable/PendingAddRatingReview";
import moment from "moment";
import { CircularProgressbar } from "react-circular-progressbar";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import AdminTwilioCallingPopup from "../superAdminPendingVendors/AdminTwilioCallingPopup";
import SendSMS from "../../superAdminReusable/reusablePopupSuperAdmin/SendSMS";
import { CHAIN_CATEGORY } from "../../../../enums/GlobalEnums";
import NoContent from "../../../reusableComponents/NoContentComponent";

const ChainsListVendor = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [activeChains, setactiveChains] = useState([]);

  useEffect(() => {
    setactiveChains(props.activeChains);
  }, [props.activeChains]);
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      {activeChains.length ?
        activeChains.slice(props.start, props.end).map((data, index) => (
          <tr className="w-100 p-0" key={index}>
            <td className="p-0 w-100">
              <table className="w-100">
                <tbody className="sd_body_css">
                  <tr
                    className="sd_body_table-row"
                    onClick={showTr}
                    style={{ cursor: "pointer" }}
                  >
                    <td style={{ width: "9%" }}>
                      <div className="f14-700">
                        <div className="vendor-main-section-one">
                          <div className="image-box">
                            <div className="Image-box-section">
                              <Image
                                fluid
                                alt="Restaurant Photo"
                                title="Restaurant Photo"
                                src={data.icon && data.icon}
                              />
                              <div className="inside-image-box-discout">
                                <Image
                                  fluid
                                  alt="Discount Picture"
                                  title="Discount Picture"
                                  src={require("../../../../assets/images/superadmin/discount.svg")}
                                />
                              </div>
                            </div>
                            <div>
                              <h5 className="font_16_m mt-2">#{++index}</h5>
                            </div>
                          </div>
                          {/* <div className="start-rating-review-box mt-2">
                        <Image
                          fluid
                          alt="wait time"
                          title="wait time"
                          className="star-image-box mr-1"
                          src={require("../../../../assets/images/superadmin/star.svg")}
                        />
                        <h5 className="font_16_m d-flex align-items-center">
                          {4.2}
                          <span className="w-100 font_10_r ml-1">
                            ({9} reviews)
                          </span>
                        </h5>
                      </div> */}
                        </div>
                      </div>
                    </td>

                    <td style={{ width: "13%" }}>
                      <h3 className="font_20_m">{data.title && data.title}</h3>
                    </td>
                    <td style={{ width: "13%" }}>
                      <h3 className="font_20_m">
                        {CHAIN_CATEGORY[data?.chain_category]}
                      </h3>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="font_18_m">
                        {data.address && data.address}
                      </div>
                    </td>
                    <td style={{ width: "10%" }}>
                      <div className="font_18_r">{data.city && data.city}</div>
                    </td>
                    <td style={{ width: "10%" }}>
                      <div className="font_18_m">
                        {data.area && data.area} <br />
                        {data.zip_code && data.zip_code}
                      </div>
                    </td>

                    <td style={{ width: "10%" }}>
                      <div className="font_18_m">
                        Fine Dine <br />
                        Italian
                        <hr className="m-1" />
                        Chain <br /> (Franchise)
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      {props.screen === "All" || props.screen === "ONHOLD" ? (
                        <div>
                          <div className="d-flex align-items-center">
                            {/* {console.log(props.screen)} */}
                            <div
                              className="btn btn-sm btn-danger mr-3"
                              onClick={() =>
                                props.screen === "All"
                                  ? props.updateStatus(data._id, "ONHOLD")
                                  : props.updateStatus(data._id, "NOTAPPROVED")
                              }
                            >
                              {props.screen === "All"
                                ? "Put On Hold"
                                : "Unhold"}
                            </div>
                            <button
                              className={`btn btn-sm btn-${
                                // props.screen === "All"
                                // ?
                                "success"
                                // : "disabled"
                                }`}
                              onClick={() => {
                                props.screen === "All" &&
                                  props.updateStatus(data._id, "APPROVED");
                              }}
                              // {...(props.screen === "ONHOLD" && "disabled")}
                              disabled={
                                props.screen === "ONHOLD" ? true : false
                              }
                            >
                              Approve
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="f14-500 mb-3">
                            {data.status && data.status === "APPROVED"
                              ? "Active"
                              : "In Active"}
                          </div>
                          <div className="d-flex">
                            {/* {console.log(data.status)} */}
                            <SlidingComponent
                              name="has_admin_approved"
                              currentState={
                                data.status && data.status === "APPROVED"
                                  ? true
                                  : false
                              }
                              type={"checkbox"}
                              toggleclass={
                                "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                              }
                              toggleinputclass={
                                "toggle__switch vendor-super-admin-toggle"
                              }
                              onChange={(e) => {
                                props.updateStatus(data._id, e.target.checked);
                              }}
                              slidingonClick={() => { }}
                              defaultChecked={
                                data.status && data.status === "APPROVED"
                                  ? true
                                  : false
                              }
                            />
                            {/* <div
                      className="p-2 f10-700 ml-2"
                      style={{
                        border: "1px solid #EE3A23",
                        borderRadius: "5px",
                      }}
                    >
                      View Dashboard
                    </div> */}
                          </div>
                        </>
                      )}
                    </td>
                  </tr>

                  {TrDetail.TrDetail && (
                    <>
                      <tr className="sd_accordion_body">
                        <td style={{ width: "20%" }}>
                          <h5 className="font_18_b mb-3">Contact</h5>
                          <div className="d-flex align-items-center">
                            <AdminTwilioCallingPopup
                              allData={{ firstName: data.title }}
                              sendData={data?.phone_numbers[0]}
                            />
                            <SendSMS
                              mobile_number={
                                data?.phone_numbers[0]?.mobile_number
                              }
                              country_code={
                                data?.phone_numbers[0]?.country_code
                              }
                            />
                            <SuperAdminNotification dataSend={data} />
                          </div>
                        </td>
                        <td style={{ width: "13%" }}>
                          <div className="font_18_b mb-4">Revenue</div>
                          <div className="font_18_b">{data?.revenue || ""}</div>
                        </td>
                        <td style={{ width: "13%" }}>
                          <div className="font_18_b mb-4">
                            Email/Phone Number
                          </div>
                          <h5 className="font_18_r">
                            {data?.enquiry_emails[0]}
                            <br />
                            {data?.phone_numbers[0]?.country_code}{" "}
                            {data?.phone_numbers[0]?.mobile_no}
                            {/* Closes: {moment(new Date()).format("HH : mm A")} */}
                          </h5>
                        </td>
                      </tr>

                      {/* <tr className="sd_accordion_body">
                        <td style={{ width: "15%" }}>
                          <div className="font_18_b mb-4">Services Offered</div>
                          <h5 className="font_14_r">
                            Takeaway, Curbside, Dine-in, Waitlist/Walkin,
                            Reservation
                          </h5>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="font_18_b mb-4">Located Inside</div>
                          <h5 className="font_14_r">Mall</h5>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="font_18_b mb-4">Liquor</div>
                          <h5 className="font_14_r">Beverages, Alchohol</h5>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="font_18_b mb-4">Cuisines</div>
                          <h5 className="font_14_r">
                            Italian, American, Mexican
                          </h5>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="font_18_b mb-4">Subscription</div>
                          <h5 className="font_14_r">
                            Seating, Events, Offers Menu Setup, ordering
                          </h5>
                        </td>
                      </tr> */}
                    </>
                  )}
                </tbody>
              </table>
            </td>
          </tr>
        )) : <NoContent />}
    </tbody>
  );
};
export default ChainsListVendor;
